import { AttributeType, RuleType } from "winslow-core";

export interface AttributeOption {
  id: AttributeType;
  label: string;
}

export interface RuleOption {
  id: RuleType;
  label: string;
}

export const ATTRIBUTE_OPTIONS: AttributeOption[] = [
  { id: AttributeType.HOME_STATE, label: "Home State" },
  { id: AttributeType.HOME_COUNTRY, label: "Home Country" },
  { id: AttributeType.WORK_STATE, label: "Work State" },
  { id: AttributeType.WORK_COUNTRY, label: "Work Country" },
  { id: AttributeType.GROUP_NAME, label: "Group Name" },
  { id: AttributeType.JOB_TITLE, label: "Job Title" },
  { id: AttributeType.EMPLOYMENT_STATUS, label: "Employment Status" },
];

export const RULE_OPTIONS: RuleOption[] = [
  { id: RuleType.IS, label: "Is" },
  { id: RuleType.IS_NOT, label: "Is Not" },
  { id: RuleType.IS_ONE_OF, label: "Is One Of" },
  { id: RuleType.IS_NOT_ONE_OF, label: "Is Not One Of" },
  { id: RuleType.CONTAINS, label: "Contains" },
  { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
];
